module.exports = __webpack_public_path__ + "img/background.2e001d2f.png";